import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from './../../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class FotografiasService {

	constructor(private http: HttpClient) { }

	getImeiList(): Observable<string[]> {
		return this.http.get<string[]>(`${environment.API_SECURITY}/api/Imagenes/ListaImei`);
	}

	getImagesList(imei: string): Observable<string[]> {
		return this.http.get<string[]>(`${environment.API_SECURITY}/api/Imagenes/ObtenerListaImagenes`, {
			params: {
				imei
			}
		});
	}

	getImage(imei, imagen) {
		return this.http.get(environment.API_SECURITY + '/api/Imagenes/ObtenerFoto?imei=' + imei + '&imagen=' + imagen, { responseType: 'blob' })
	}
}
